import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { useQuery } from '@tanstack/react-query';
import { Space, Select, Typography } from 'antd';
import uniqBy from 'lodash/uniqBy';
import { getTranslatedString } from 'helpers/i18n';
import { apiGet } from 'helpers/ApiHelper';

const { Text } = Typography;

const fetchAgentProperties = async (userId) => {
  const response = await apiGet(`/landlords/user`, { user_type: 'Agent', user_id: userId });

  return response?.user?.properties || [];
};

const ApplicationApprovalNotificationsSettings = ({ userId }) => {
  const { data: properties } = useQuery({
    queryKey: ['agentProperties', userId],
    queryFn: () => fetchAgentProperties(userId),
  });

  const options = uniqBy(properties || [], (property) => property.value).map(
    ({ value, label }) => ({ value, label })
  );

  return (
    <Field
      name="application_approval_notifications_settings.properties"
      label={getTranslatedString(
        'landlordPortal.userPreferencesForm.label.applicationReviewNotifications.properties'
      )}
      component={(field) => {
        return (
          <Space direction="vertical" style={{ width: '100%', marginTop: 8 }}>
            <Text>
              {getTranslatedString(
                'landlordPortal.userPreferencesForm.label.applicationReviewNotifications.properties'
              )}
            </Text>
            <Select
              mode="multiple"
              options={options}
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
              value={field.input.value}
              style={{ width: '100%' }}
              onChange={field.input.onChange}
            />
          </Space>
        );
      }}
    />
  );
};

export default connect((state) => ({
  userId: state.userTypes.userId,
}))(ApplicationApprovalNotificationsSettings);
